import React from "react";
import { useTranslation } from 'gatsby-plugin-react-i18next';
import ContactForm from "../components/contactForm";
import CallToActionButton from "../components/callToActionButton";
import { sectionHeaderChildrenVariants, sectionHeaderVariants } from "../../../utils/animations";
import { motion } from "framer-motion";
import { useMediaQuery } from "react-responsive";

const Contact = ({ serviceName }) => {
  const {t} = useTranslation();

  const isMobile = useMediaQuery({ query: '(max-width: 993px)' });

  return(
    <div className="sub-page-section" style={{ paddingBottom: '100px' }}>
      <div className="container">
        <motion.div
          className="sub-page-section-header"
          initial="offscreen"
          whileInView="onscreen"
          viewport={{ once: true, amount: isMobile ? 0.2 : 1 }}
          variants={sectionHeaderVariants}
        >
          <motion.h2 variants={sectionHeaderChildrenVariants}>
          {t("contact-title-before")}
          </motion.h2>
        </motion.div>

        <div className="row">
          <div className="col-md-6" style={{ marginBottom: '2rem' }}>
            <div className="card-contact" style={{ height: '100%' }}>
              <p className="description-text">{t("contact-description-1")}</p>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <CallToActionButton text={t("contact-call-button")} color="#9340ff" />
              </div>
            </div>
          </div>

          <div className="col-md-6" style={{ marginBottom: '2rem' }}>
            <div className="card-contact" style={{ height: '100%' }}>
              <p className="description-text">{t("contact-description-2")}</p>
              <ContactForm serviceName={serviceName} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;